import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "antd/lib/card";
import Tag from "antd/lib/tag";

import { IconCloudStorm } from "@tabler/icons-react";

import styles from "./regions-card.module.css";

export default function RegionsCard({ selectedRegions, regionData, setSelectedRegionForEdit }) {
    return (
        <div className={styles.regionCardsGrid}>
          {selectedRegions.map((region) => {
            const data = regionData[region] || {};
            return (
              <Card
                key={region}
                className={`${styles.regionCardGrid} ${data.loading ? styles.loading : ''}`}
                hoverable
                onClick={() => setSelectedRegionForEdit(region)}
              >
                {data.loading ? (
                  <div className={styles.regionCardLoading}>
                    <IconCloudStorm size={24} />
                    <Typography>Configuring {region}...</Typography>
                  </div>
                ) : (
                  <div className={styles.regionCardContent}>
                    <Typography variant="h6">{region}</Typography>
                    <div className={styles.regionCardStats}>
                      <Tag color="blue">
                        {data.selectedSites?.length || 0} Sites
                      </Tag>
                      {data.message && <Tag color="green">Configured</Tag>}
                    </div>
                    <Typography variant="body2" className={styles.regionCardMessage}>
                      {data.message
                        ? data.message.substring(0, 50) +
                          (data.message.length > 50 ? '...' : '')
                        : 'No message generated'}
                    </Typography>
                    <Button
                      variant="contained"
                      className={styles.editButton}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedRegionForEdit(region);
                      }}
                    >
                      Edit
                    </Button>
                  </div>
                )}
              </Card>
            );
          })}
        </div>
    )
}